import { render, staticRenderFns } from "./OperaWarehouseDataWindow.vue?vue&type=template&id=508697f3&scoped=true"
import script from "./OperaWarehouseDataWindow.vue?vue&type=script&lang=js"
export * from "./OperaWarehouseDataWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaWarehouseDataWindow.vue?vue&type=style&index=0&id=508697f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508697f3",
  null
  
)

export default component.exports